<div class="vehicle-details-content">
  <div class="vehicle-header">
    <h3 class="section-title">{{ sectionTitle }}</h3>
    <button
      type="button"
      class="add-vehicle-link"
      *ngIf="showAddVehicleHeaderAction"
      (click)="onAddNewVehicle()"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 3.33333V12.6667M3.33333 8H12.6667"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      {{ addButtonText }}
    </button>
  </div>
  <div class="white-pane">
    <div
      class="vehicle-step-loading"
      *ngIf="isVehicleInventoryLoading"
      role="status"
      aria-live="polite"
    >
      <div class="vehicle-step-loading-spinner" aria-hidden="true"></div>
      <p class="vehicle-step-loading-text">Loading vehicles…</p>
    </div>

    <div class="scrollable-content" *ngIf="!isVehicleInventoryLoading">
      <div class="vehicle-section-header" *ngIf="showVehicleSectionBanner">
        <h4 class="section-subtitle" *ngIf="headerText !== sectionTitle">{{ headerText }}</h4>
        <span
          class="family-plan-suggestion"
          *ngIf="showFamilyPlanSuggestion && !isSelectedPackageFamilyPlan"
        >
          💡 This customer visits often — consider adding a family plan.
        </span>
      </div>

      <!-- ── Existing vehicles (returned customer) ── -->
      <div *ngIf="hasExistingVehicles && familyVehicleSlots.length > 0" class="existing-vehicles">
        <div
          *ngFor="let slot of familyVehicleSlots; let i = index; trackBy: trackBySlotId"
          class="vehicle-item-wrapper"
        >
          <!-- Display mode -->
          <ng-container *ngIf="!isEditingVehicle || vehicleToEditIndex !== i">
            <app-vehicle-item
              [vehicleData]="toVehicleItemData(slot)"
              [isSelected]="slot.bookForWash"
              [showActions]="true"
              [isMenuOpen]="openMenuVehicleId === slot.id"
              (selectVehicle)="toggleVehicleSelection(i)"
              (editVehicle)="editVehicle(slot, i)"
              (deleteVehicle)="deleteVehicle(slot, i)"
              (toggleMenu)="openMenuVehicleId = openMenuVehicleId === slot.id ? null : slot.id"
            >
            </app-vehicle-item>
          </ng-container>

          <!-- Edit mode -->
          <div *ngIf="isEditingVehicle && vehicleToEditIndex === i" class="vehicle-edit-form">
            <app-vehicle-list
              [isEditMode]="true"
              [editVehicleData]="editingVehicleData!"
              [showSaveCancelButtons]="true"
              [showBookingCheckbox]="false"
              [customerId]="customerId"
              (cancelEdit)="onCancelEdit()"
              (saveEdit)="onSaveEdit($event)"
            >
            </app-vehicle-list>
          </div>
        </div>

        <!-- Add vehicle for existing user section -->
        <div *ngIf="isAddingForExistingUser" class="add-vehicle-section">
          <app-add-vehicle-form
            [vehicleForm]="{
              state: newVehicleForm.selectedState,
              licensePlate: newVehicleForm.licensePlate,
            }"
            [vehicleData]="newVehicleForm.vehicleData"
            [isLoadingVehicle]="newVehicleForm.isLoading"
            [vehicleErrorMessage]="newVehicleForm.errorMessage"
            [headerText]="'Add Vehicle'"
            [showHeader]="true"
            [showSaveCancelButtons]="true"
            [customerId]="customerId"
            (vehicleDataChange)="newVehicleForm.vehicleData = $event"
            (vehicleCreatedManually)="onNewVehicleCreatedForExistingCustomer($event)"
            (customerDataChange)="onCustomerDataChange($event)"
            (cancel)="onCancelAddVehicle()"
          >
          </app-add-vehicle-form>

          <!-- A looked-up vehicle is only fetched, never stored (CWS-1398), so this form
               needs the same explicit Save the slot forms have. The manual-entry path
               saves from inside the form and closes this section, so it never shows. -->
          <div class="slot-actions" *ngIf="newVehicleForm.vehicleData">
            <button
              class="save-button"
              [disabled]="newVehicleForm.isLoading"
              (click)="onSaveNewVehicleForExistingCustomer()"
            >
              {{ newVehicleForm.isLoading ? 'Saving...' : 'Save Vehicle' }}
            </button>
          </div>
        </div>
      </div>

      <!-- ── New vehicle form slots ── -->
      <div
        *ngFor="let slot of vehicleFormSlots; let i = index; trackBy: trackBySlotId"
        class="vehicle-form-slot"
      >
        <!-- Header row: vehicle title + trash icon (only shown when multiple vehicles) -->
        <div *ngIf="hasMultipleVehicles" class="vehicle-form-header">
          <h5 class="vehicle-form-title">{{ addVehicleFormCardTitle(i) }}</h5>
          <button
            type="button"
            class="delete-vehicle-btn"
            (click)="onRemoveVehicleForm(i)"
            title="Remove Vehicle"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 6H5H21"
                stroke="#DC2626"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
                stroke="#DC2626"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M10 11V17"
                stroke="#DC2626"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M14 11V17"
                stroke="#DC2626"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>

        <app-add-vehicle-form
          [vehicleForm]="{
            state: slot.formData.selectedState,
            licensePlate: slot.formData.licensePlate,
          }"
          [vehicleData]="slot.vehicleData"
          [isLoadingVehicle]="slot.isLoading"
          [vehicleErrorMessage]="slot.errorMessage"
          [isBookingChecked]="slot.bookForWash"
          [isBookingDisabled]="!hasMultipleVehicles"
          [showBookingCheckbox]="hasMultipleVehicles"
          [isRadioButton]="true"
          [headerText]="'Add Vehicle'"
          [showHeader]="!hasMultipleVehicles"
          [showSaveCancelButtons]="hasExistingVehicles"
          [customerId]="customerId"
          (vehicleFormChange)="onVehicleFormDataChange($event, i)"
          (vehicleDataChange)="onVehicleDataChange($event, i)"
          (vehicleCreatedManually)="onManualVehicleCreatedForSlot($event, i)"
          (vehicleErrorMessageChange)="vehicleFormSlots[i].errorMessage = $event"
          (isLoadingVehicleChange)="vehicleFormSlots[i].isLoading = $event"
          (customerDataChange)="onCustomerDataChange($event)"
          (bookingChange)="onVehicleFormBookingChange($event, i)"
          (cancel)="onCancelVehicleForm(i)"
        >
        </app-add-vehicle-form>

        <!-- Save button for new slot in existing user flow -->
        <div
          class="slot-actions"
          *ngIf="hasExistingVehicles && slot.formData?.vehicleData && !slot.formData.vehicleId"
        >
          <button class="save-button" [disabled]="slot.isLoading" (click)="onSaveVehicleForm(i)">
            {{ slot.isLoading ? 'Saving...' : 'Save Vehicle' }}
          </button>
        </div>
      </div>

      <span class="vehicle-limit-note" *ngIf="isVehicleLimitReached && showAddVehicleHeaderAction">
        (Maximum 5 vehicles)
      </span>
    </div>

    <!-- Actions -->
    <div class="vehicle-details-actions">
      <button class="cancel hide-cancel-mobile" (click)="cancel.emit()">Cancel</button>
      <button class="back mobile-back" (click)="back.emit()">Back</button>
      <div class="footer-right">
        <button class="back desktop-back" (click)="back.emit()">Back</button>
        <button
          class="continue"
          [disabled]="
            !isVehicleFormValid || hasUnsavedVehicles || isLoading || isVehicleInventoryLoading
          "
          (click)="onContinue()"
        >
          <span *ngIf="isLoading">Processing...</span>
          <span *ngIf="!isLoading">Continue</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Delete confirmation modal -->
<app-alert-modal
  [isOpen]="showDeleteModal"
  title="Remove Vehicle"
  [description]="
    isDeletingToSwitchToIndividualPlan
      ? 'Removing this vehicle will switch the customer back to an individual plan. Continue?'
      : 'Are you sure you want to remove this vehicle?'
  "
  primaryButtonText="Remove"
  secondaryButtonText="Cancel"
  (close)="onDeleteModalCancel()"
  (primaryAction)="onDeleteModalConfirm(vehicleToDelete)"
  (secondaryAction)="onDeleteModalCancel()"
>
</app-alert-modal>

<!-- Family plan alert modal -->
<app-alert-modal
  [isOpen]="showFamilyPlanAlert"
  title="Add another vehicle and switch plans?"
  [description]="familyPlanAlertDescription"
  additionalDescription="Do you want to continue?"
  primaryButtonText="Add Vehicle (Family Plan)"
  secondaryButtonText="Cancel"
  (close)="onFamilyPlanAlertCancel()"
  (primaryAction)="onFamilyPlanAlertConfirm()"
  (secondaryAction)="onFamilyPlanAlertCancel()"
>
</app-alert-modal>
